import React from 'react';

import { Box, Separator, Skeleton } from '@ublend-npm/aulaui-core';

const ParticipantHistoryLoader = React.forwardRef<HTMLElement>(
  (_props, ref) => {
    return (
      <Box ref={ref}>
        <Skeleton height={105} kind="text" />
        <Separator size="thin" />
        <Skeleton height={105} kind="text" />
        <Separator size="thin" />
        <Skeleton height={105} kind="text" />
      </Box>
    );
  }
);

export default ParticipantHistoryLoader;
